export enum Role {
  Admin = 'admin',
  Patient = 'patient',
}
